export const corners = {
    default: { full: 9999, box: { outside: 50, inbetween: 35, inside: 28 } },
    hoteles: { full: 4, box: { outside: 4, inbetween: 4, inside: 4 } },
};
